module.exports = __webpack_public_path__ + "img/menu.6c7840fd.svg";